/**
 * 년도별 통계 특징 데이터
 */
export const ColonicalInfoData =
    [
        {
            1917: {
                id: 1,
                year: 1917,
                content: "1917년도판\n일람의 기재 순서는 내지인 제학교일람과 교육기관 일람으로 시작되고 그 뒤에 조선인 통계로 제학교일람과 교육기관 일람이 정리되어 있다.\n교육기관은 관공립, 사립 순으로 정리되어 있다.\n 여학교는 표 하나로 정리되어 있다.\n사립각종학교와 서당에 대해서는 전국 총계와 지역별 합계만 정리되어 있다.\n 소학교, 보통학교 ‘학생 건강’, ‘체격 조사’가 포함되어 있다."
            },
            1918: {
                id: 2,
                year: 1918,
                content: "1918년도판\n일람의 기재 순서는 내지인 제학교일람과 교육기관 일람으로 시작되고 그 뒤에 조선인 통계로 제학교일람과 교육기관 일람이 정리되어 있다.\n교육기관은 관공립, 사립 순으로 정리되어 있다.\n여학교는 표 하나로 정리되어 있다.\n사립각종학교와 서당에 대해서는 전국 총계와 지역별 합계만 정리되어 있다.\n부록에 '도서관일람'이 새로 등장한다.\n부록에 '관공립사립학교 입학 상황표'가 새로 추가되었다. 소학교, 보통학교에 대해서는 설립 주체별 합계만 정리되어 있고 그 이외 학교에 대해서는 개별 학교 현황까지 기재되어 있다.\n1917년도판에 있었던 건강, 체격 관련 내용이 없어졌다."
            },
            1919: {
                id: 3,
                year: 1919,
                content: "1919년도판\n일람의 기재 순서는 내지인 제학교일람과 교육기관 일람으로 시작되고 그 뒤에 조선인 통계로 제학교일람과 교육기관 일람이 정리되어 있다.\n교육기관은 관공립, 사립 순으로 정리되어 있다.\n여학교는 표 하나로 정리되어 있다.\n사립각종학교와 서당에 대해서는 전국 총계와 지역별 합계만 정리되어 있다."
            },
            1921: {
                id: 4,
                year: 1921,
                content: "1921년도판\n보통학교와 소학교 상세 목록은 관립만 정리되어 있고 공립과 사립은 전국 및 지역 합계만 정리되어 있다.\n부록(도서관표, 학교조합예산표, 공립보통학교예산표, 학교림 조사표, 학교생도 입학 상황표)가 없다.\n공사립 보통학교와 소학교 일람, 부록이 없는 관계로 자료 분량이 적다.\n조선인 사립각종학교 일람은 전국 총계와 지역별 합계만 기재되어 있다."
            },
            1922: {
                id: 5,
                year: 1922,
                content: "1922년도판\n목차에서 '내지인교육' 및 '조선인교육'으로 표기되었던 큰 분류 체제는 없어졌다. 기재 순서는 일본인 학교조선인 학교 순으로 기재되어 있다.\n소학교, 보통학교, 중학교는 설립 주체별(관립, 공립, 사립)로 정리되어 있다.\n실업학교는 조선인과 일본인 공학으로 전환되었다.\n각종학교는 공립과 사립이 따로 정리되어 있다.\n각종학교 목록은 공립만 기재되어 있고 사립은 전국 총계와 지역별 합계만 정리되어 있다.\n부록이 없어지고 도서관일람과 서당이 교육기관 항목과 동일한 분류로 기재되어 있다.\n전문학교, 각종학교, 유치원은 조선인과 일본인을 같은 표 안에 정리되어 있다.\n1921년도판까지 부록에 기재되었던 예산 및 입학 관련 통계가 없어졌다."
            },
            1923: {
                id: 6,
                year: 1923,
                content: "1923년도판\n목차에서 사립 소학교, 공립중학교가 추가되었다.\n목차에서 고등보통학교, 여자고등보통학교가 관공립에서 관사립으로 기재되어 있다.\n목차에서 한 항목으로 정리되어 있었던 실업학교가 관공농업학교와 관공사립 상업, 상공, 공업, 수산학교로 분리되었다.\n1922년도판에 없어진 부록이 다시 등장하고 서당, 공사립유치원, 도서관일람표가 부록으로 정리되어 있다.\n소학교와 보통학교 목록은 관립만 정리되어 있고 공립과 사립은 전국 총계와 지역별 합계만 정리되어 있다.\n각종학교에 대해서는 전국 총계와 지역별 합계만 기재되어 있다.\n사립 각종학교 목록은 조선인과 일본인 학교를 별도로 정리되어 있다."
            },
            1924: {
                id: 7,
                year: 1924,
                content: "1924년도판\n목차에서 보습학교가 전문별로 정리되었다.\n관립대학예과가 등장한다.\n소학교와 보통학교 목록은 관립만 정리되어 있고 공립과 사립은 전국 총계와 지역별 합계만 정리되어 있다.\n각종학교에 대해서는 전국 총계와 지역별 합계만 기재되어 있다."
            },
            1925: {
                id: 8,
                year: 1925,
                content: "1925년도판\n목차에서 관립중학교가 없어졌다.\n소학교와 보통학교는 관립만 학교별로 정리되어 있으며 있고 공립과 사립은 전국 총계와 지역별 합계만 정리되어 있다.\n목차에서 '관공립농업학교'가 '관공사립농업, 농잠, 농림학교' 표기로 변경되었다.\n목차에서 '공사립상업보습학교'가 '공립상업보습학교' 표기로 변경되었다.\n목차에서 '서당'이 '서당조' 표기로 변경되었다.\n목차에서 유치원과 도서관에 대한 기재 순서가 도서관, 유치원 순으로 변경되었다.\n목차에서 '도서관'과 '유치원' 표기 앞에 '공사립' 표기가 추가되었다.\n각종학교에 대해서는 전국 총계와 지역별 합계만 기재되어 있다."
            },
            1926: {
                id: 9,
                year: 1926,
                content: "1926년도판\n'안동현공립보통학교급간도훈춘각종학교'가 등장한다.\n목차에서 '관사립고등보통학교'와 '관사립여자고등보통학교'가 '공사립고등보통학교'와 '공사립여자고등보통학교' 표기로 변경되었다.\n목차에서 농업보습학교가 '농업, 농잠보습학교' 표기로 변경되었다.\n목차에 공립수산보습학교가 추가되었다.\n목차에서 '관사립전문학교'가 '관립전문학교'와 '사립전문학교'로 분리되었다.\n목차에서 '관립대학예과'가 '관립경성제국대학예과' 표기로 변경되었다.\n목차에서 '관공립사범학교'가 '관립사범학교'와 '공립사범학교'로 분리되었다.\n목차에서 '도서관'과 '유치원'에 대한 기재 순서가 변경되어 '유치원', '도서관' 순으로 정리되어 있다.\n목차에서 '공립도서관'이 '관공사립도서관' 표기로 변경되었다.\n각종학교 목록은 일본인 학교만 정리되어 있고 조선인 학교는 전국 총계와 지역별 합계만 기재되어 있다."
            },
            1927: {
                id: 10,
                year: 1927,
                content: "1927년도판\n목차에서 '관립경성제국대학예과'가 '경성제대예과' 표기로 변경되었다.\n목차에서 '안동현공립보통학교급간도훈춘각종학교'가 '훈춘각학교' 표기로 변경되었다.\n목차에서 실업학교로 '실업'이 추가되었다.\n목차에서 실업보습학교로 '실과 여학교'가 추가되었다.\n각종학교 중 조선인 학교(일부 내지인 포함)에 대해서는 전국 총계와 지역별 합계만 정리되어 있다."
            },
            1928: {
                id: 11,
                year: 1928,
                content: "1928년도판\n목차에서 '사립소학교'가 없어졌다.\n목차에 '사립공업보습학교' 추가되었다.\n목차에서 '관립경성제국대학예과'가 '경성제국대학예과' 표기로 변경되었다.\n경성제국대학이 등장한다.\n각종학교 중 조선인 학교(일부 내지인 포함)에 대해서는 전국 총계와 지역별 합계만 정리되어 있다.\n부록의 기재 순서가 '서당', '공사립유치원', '관공사립도서관'에서 '공사립유치원', '서당조', '관공사립도서관'으로 변경되었다."
            },
            1929: {
                id: 12,
                year: 1929,
                content: "1929년도판\n목차에서 '공립실업보습학교'가 추가되었다.\n각종학교 중 조선인 학교(일부 내지인 포함)에 대해서는 전국 총계와 지역별 합계만 정리되어 있다."
            },
            1930: {
                id: 13,
                year: 1930,
                content: "1930년도판\n목차에서 '사립고등여학교'가 추가되었다.\n목차에서 '공립농업, 농잠, 농림보습학교' 표기가 '관공립농업, 농잠 보습학교'로 변경되었으나 본문 일람에서 관립학교가 존재하지 않다(목차 표기는 오기로 추정된다).\n목차에서 '사립공업보습학교' 없어졌다.\n목차에서 '서당조' 표기가 '서당'으로 변경되었다.\n각종학교 중 조선인 학교(일부 내지인 포함)에 대해서는 전국 총계와 지역별 합계만 정리되어 있다."
            },
            1931: {
                id: 14,
                year: 1931,
                content: "1931년도판\n공립직업학교 추가되었다.\n시립고등실업여학교가 추가되었다.\n목차에서 '공립사범학교'와 '공립각종학교'가 없어졌다.\n각종학교 중 조선인 학교(일부 내지인 포함)에 대해서는 전국 총계와 지역별 합계만 정리되어 있다."
            },
            1932: {
                id: 15,
                year: 1932,
                content: "1932년도판\n목차에서 '공립직업학교'와 '사립고등실업여학교'가 없어졌다.\n목차에서 '공립농업, 농잠보습학교'에 '농림'이 추가되었다.\n목차에서 사립농업보습학교 추가되었다.\n공목차에서 '공립기업보습학교'가 추가되었다.\n각종학교 중 조선인 학교(일부 내지인 포함)에 대해서는 전국 총계와 지역별 합계만 정리되어 있다."
            },
            1933: {
                id: 16,
                year: 1933,
                content: "1933년도판\n목차에서 '관공사립 상업, 상공, 공업, 수산, 실업, 실업보습학교' 표기에서 '실업보습학교'가 없어졌다.\n목차에서 '관립농업보습학교', '사립상업보습학교', '공립여자실수학교', '공립전문학교'가 한 항목으로 독립되었다.\n목차에서 '경성제국대학', '경성제국대학 예과' 표기가 '관립대학', '관립대학 예과'로 변경되었다.\n각종학교 중 조선인 학교(일부 내지인 포함)에 대해서는 전국 총계와 지역별 합계만 정리되어 있다.\n목차에 '사립각종학교(초등)'가 추가되었으나 본문 표에서는 '사립각종학교(조선인)'으로 표기되어 있다.\n목차에는 '부록' 항목이 없으나 본문에는 '공사립유치원', '서당', '관공사립도서관' 표가 존재한다."
            },
            1934: {
                id: 17,
                year: 1934,
                content: "1934년도판\n'공립보통학교부설간이학교'가 등장한다.\n목차에는 '부록' 항목이 없으나 본문에는 '공사립유치원', '서당', '관공사립도서관' 표가 존재한다.\n각종학교 중 조선인 학교(일부 내지인 포함)에 대해서는 전국 총계와 지역별 합계만 정리되어 있다.\n목차의 '사립각종학교(초등)'은 본문 표에서는 '사립각종학교(조선인)'으로 표기되어 있다."
            },
            1935: {
                id: 18,
                year: 1935,
                content: "1935년도판\n목차에는 '부록' 항목이 없으나 본문에는 '공사립유치원', '서당', '관공사립도서관' 표가 존재한다.\n각종학교 중 조선인 학교(일부 내지인 포함)에 대해서는 전국 총계와 지역별 합계만 정리되어 있다.\n목차의 '사립각종학교(초등)'은 본문 표에서는 '사립각종학교(조선인)'으로 표기되어 있다."
            },
            1936: {
                id: 19,
                year: 1936,
                content: "1936년도판\n'간도 훈춘내 각학교' 표기가 '간도성내 각학교'로 변경되었다.\n목차에서 설립 주체별로 표기되어 있었던 '농업보습학교'가 '관공사립농업, 농잠, 농림보습학교'로 통합 표기되어 있다.\n목차에서 학교 종류별로 기재되어 있었던 실업보습학교가 '농업보습학교'를 제외하고 '공사립상업, 공업, 수산, 기업, 기타실업보습학교' 한 항목으로 통합 표기되어 있다.\n부록의 순소가 '공사립유치원', '관공사립도서관', '서당'에서 '공사립유치원', '서당', '관공사립도서관' 순으로 변경되었다.\n소학교와 보통학교 일람에서 개별 학교 통계가 없어지고 학교 목록, 전국 총계와 지역별 합계만 기재되어 있다. 통계 내용이 '학교 수', '학급 수', '학생 수'만 정리되어 있다.\n각종학교 중 조선인 학교(일부 내지인 포함)에 대해서는 전국 총계와 지역별 합계만 정리되어 있다."
            },
            1937: {
                id: 20,
                year: 1937,
                content: "1937년도판\n소학교와 보통학교 일람에 대해서는 개별 학교 통계가 없고 학교 목록, 전국 총계와 지역별 합계만 기재되어 있다. 통계 내용이 '학교 수', '학급 수', '학생 수'만 정리되어 있다.\n1936년도판까지 기재되었던 '간도성내 각학교'가 없어졌다.\n목차에서 '농업보습학교'에서 '관립' 표기가 없어졌다."
            },
            1938: {
                id: 21,
                year: 1938,
                content: "1938년도판\n1937년도판까지 조선인 학교의 명칭이었던 '보통학교', '고등보통학교', '여자고등보통학교'가 없어지고 일본인 학교와 같은 명칭인 '소학교', '중학교', '고등여학교'로 변경되었다.\n학교의 기재 순서는 일본인 학교조선인 학교 순으로 정리되어 있다.\n소학교 일람에서 개별 학교 통계가 없어지고 전국 총계와 지역별 합계만 기재되어 있다.\n'보통학교부설간이학교'는 ‘소학교부설간이학교’로 변경되었다.\n목차에 ‘사립중학교’ 항목이 추가되었다."
            },
            1939: {
                id: 22,
                year: 1939,
                content: "1939년도판\n학교의 기재 순서는 일본인 학교조선인 학교 순으로 정리되어 있다.\n소학교 일람에 대해서는 개별 학교 통계가 없고 전국 총계와 지역별 합계만 기재되어 있다."
            },
            1940: {
                id: 23,
                year: 1940,
                content: "1940년도판\n학교의 기재 순서는 일본인 학교조선인 학교 순으로 정리되어 있다.\n소학교 일람에 대해서는 개별 학교 통계가 없고 전국 총계와 지역별 합계만 기재되어 있다.\n목차의 ‘실업학교’ 항목에서 ‘관립’ 표기가 없어졌다."
            },
            1941: {
                id: 24,
                year: 1941,
                content: "1941년도판\n‘도지사인정학교’ 등장한다\n‘소학교’ 명칭이 ‘국민학교‘로 변경되었다.\n‘공립소학교부설간이학교’가 ‘공립국민학교부설간이학교’로 변경되었다."
            },
            1942: {
                id: 25,
                year: 1942,
                content: "1942년도판\n‘사립각종학교’ 표기가 학교급 별로 구분되어 ‘전문정도각종학교’와 ‘중등정도각종학교’로 변경되었다\n‘사립각종학교(초등)’이 부록으로 분류되었다.\n목차에서 ‘관공사립도서관’ 표기가 ‘도서관표’로 변경되었다."
            },
            1943: {
                id: 26,
                year: 1943,
                content: "1943년도판\n목차에서 ‘제학교일람표’ 표기가 ‘학교 총람’으로 변경되었다\n목차에서 ‘공립국민학교’ 표기가 ‘공립국민학교(1)’과 ‘공립국민학교(2)’로 구분되었다.\n목차에서 실업학교 항목이 전문별로 구성되어 있다.\n목차에서 ‘실업보습학교’ 표기에서 ‘기업’이 없졌다.\n목차에서 ‘공립여자실업보습학교’가 추기되었다.\n목차에서 ‘중등정도각종학교’ 항목이 ‘관립전문학교’ 앞으로 변경되었다.\n‘사립각종학교(초등)’ 표기에서 ‘초등’ 표기가 없어졌다."
            }
        }
    ]


